export default "__VITE_ASSET__C7JLZIUZ__"